import { render, staticRenderFns } from "./Bands.vue?vue&type=template&id=68d0a94c&scoped=true"
import script from "./Bands.vue?vue&type=script&lang=js"
export * from "./Bands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0a94c",
  null
  
)

export default component.exports